/* basis-reviews-wall
   ---------------------------------------------------------------------------
   Deux roles, aucun autre :
     1. repartir les avis en 1 / 2 / 3 colonnes selon la largeur d'ecran
     2. dupliquer chaque colonne pour que la boucle CSS soit sans couture

   Pourquoi la repartition est en JS et pas en Liquid : le nombre de colonnes
   depend de la largeur du viewport, que Liquid ignore (rendu serveur). Avec
   3 colonnes figees dans le HTML, passer a 1 colonne sur mobile ferait sortir
   les colonnes 2 et 3 du cadre masque : les deux tiers des avis
   disparaitraient en silence.

   Sans JS : la liste plate rendue par le snippet s'affiche telle quelle, sans
   animation. Degradation propre, aucun avis perdu, tout reste crawlable.

   Plafond mobile : en 1 colonne, 27 avis dupliques donnent une piste de
   ~14 700 px (mesure). C'est un calque composite au-dela de ce que beaucoup de
   GPU mobiles encaissent (limite de texture frequente a 16 384 px) : zones
   blanches ou clignotement, typiquement sur iOS. D'ou data-max-mobile, expose
   en reglage de section plutot que cache ici.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  function initWall(root) {
    if (root.dataset.rwallReady === '1') return;
    root.dataset.rwallReady = '1';

    var wall = root.querySelector('.rwall__wall');
    if (!wall) return;

    var maxMobile = parseInt(root.dataset.maxMobile, 10);
    if (!maxMobile || maxMobile < 1) maxMobile = 12;

    // Corpus de reference, capture une fois avant toute manipulation.
    // Le snippet rend tous les avis dans UNE colonne : on part de la.
    var cards = Array.prototype.map.call(
      wall.querySelectorAll('.rwall__card:not(.is-dup)'),
      function (c) { return c.cloneNode(true); }
    );
    if (!cards.length) return;

    function colCount() {
      var w = window.innerWidth;
      return w >= 1000 ? 3 : (w >= 700 ? 2 : 1);
    }

    var current = null;

    function build() {
      var n = colCount();
      if (n === current) return;
      current = n;

      wall.innerHTML = '';
      var tracks = [];
      for (var i = 0; i < n; i++) {
        var col = document.createElement('div');
        col.className = 'rwall__col';
        var track = document.createElement('div');
        track.className = 'rwall__track';
        col.appendChild(track);
        wall.appendChild(col);
        tracks.push(track);
      }

      // distribution en serpentin : les cartes longues ne s'empilent pas
      // toutes dans la meme colonne
      var items = (n === 1) ? cards.slice(0, maxMobile) : cards;
      items.forEach(function (card, i) {
        tracks[i % n].appendChild(card.cloneNode(true));
      });

      // seconde copie = boucle sans couture (translateY(-50%)).
      // aria-hidden pour ne pas faire lire chaque avis deux fois.
      tracks.forEach(function (track) {
        Array.prototype.forEach.call(
          track.querySelectorAll('.rwall__card'),
          function (card) {
            var copy = card.cloneNode(true);
            copy.classList.add('is-dup');
            copy.setAttribute('aria-hidden', 'true');
            track.appendChild(copy);
          }
        );
      });
    }

    build();

    var timer;
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(build, 200);
    });

    // Mouvement reduit : le mur ne defile plus tout seul, il se parcourt a la
    // main (cf. le bloc @media du CSS). Une zone defilable doit etre
    // atteignable au clavier, sinon son contenu devient inaccessible - d'ou le
    // tabindex, pose ici seulement parce que le CSS ne peut pas le faire.
    var reduit = window.matchMedia('(prefers-reduced-motion: reduce)');
    function majAccesClavier() {
      if (reduit.matches) {
        wall.setAttribute('tabindex', '0');
        wall.setAttribute('role', 'group');
        wall.setAttribute('aria-label', 'Avis clients, liste défilante');
      } else {
        wall.removeAttribute('tabindex');
        wall.removeAttribute('role');
        wall.removeAttribute('aria-label');
      }
    }
    majAccesClavier();
    if (reduit.addEventListener) reduit.addEventListener('change', majAccesClavier);

    // Commande de pause (WCAG 2.2.2). Le defilement lui-meme est en CSS pur :
    // il tourne meme si ce script ne s'execute pas.
    var btn = root.querySelector('.rwall__pause');
    if (btn) {
      var label = btn.querySelector('[data-rwall-label]');
      var textPause = btn.dataset.labelPause || 'Mettre le défilement en pause';
      var textPlay = btn.dataset.labelPlay || 'Reprendre le défilement';
      btn.addEventListener('click', function () {
        var paused = root.classList.toggle('is-paused');
        btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        if (label) label.textContent = paused ? textPlay : textPause;
      });
    }
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('.rwall');
    Array.prototype.forEach.call(roots, initWall);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Personnalisateur : une section rechargee doit se reinitialiser.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
